import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CaretDownIcon, CaretUpIcon, GlobeIcon } from '@bnb-chain/icons';
import { Box, Menu, MenuButton, MenuItemOption, MenuList, MenuOptionGroup, useColorMode, } from '@chakra-ui/react';
import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { getTextByLocale, SUPPORTED_LOCALES } from '../../../../../modules/intl/constants';
import { theme } from '../../../../../modules/theme';
import { Typography } from '../../../../Typography';
import { Context } from '../../../context';
import { toLocalePathname } from '../../../utils';
export const Medium = () => {
    const { colorMode } = useColorMode();
    const { locale } = useIntl();
    const { pathname } = useContext(Context);
    const handleClick = (locale) => {
        if (typeof document === 'undefined')
            return;
        // Set the preferred language in a cookie
        document.cookie = `userPreferredLanguage=${locale};path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT`;
        const link = toLocalePathname(pathname, locale);
        setTimeout(() => {
            window.location.href = link;
        }, 100);
    };
    return (_jsx(Menu, { placement: "top-end", strategy: 'fixed', children: ({ isOpen }) => (_jsxs(_Fragment, { children: [_jsx(MenuButton, { transition: 'all .15s', sx: {
                        '@media (hover:hover)': {
                            _hover: {
                                color: isOpen
                                    ? theme.colors[colorMode].text.brand
                                    : theme.colors[colorMode].text.primary,
                            },
                        },
                    }, color: isOpen ? theme.colors[colorMode].text.brand : theme.colors[colorMode].text.tertiary, children: _jsxs(Box, { display: "flex", alignItems: "center", children: [_jsx(GlobeIcon, { fontSize: theme.sizes['5'] }), "\u00A0", _jsx(Typography, { as: "span", variant: "label", size: "md", fontWeight: "500", children: getTextByLocale(locale) }), isOpen ? (_jsx(CaretUpIcon, { fontSize: theme.sizes['5'] })) : (_jsx(CaretDownIcon, { fontSize: theme.sizes['5'] }))] }) }), _jsx(MenuList, { bg: theme.colors[colorMode].layer[3].default, borderRadius: theme.sizes['2'], py: theme.sizes['2'], border: "none", boxShadow: "none", children: _jsx(MenuOptionGroup, { defaultValue: locale, type: "radio", children: Object.keys(SUPPORTED_LOCALES).map((it) => (_jsx(MenuItemOption, { icon: null, value: it, px: theme.sizes['6'], py: theme.sizes['3'], w: "100%", color: it === locale
                                ? theme.colors[colorMode].text.brand
                                : theme.colors[colorMode].text.secondary, bg: "none", _hover: {
                                bg: theme.colors[colorMode].layer[3].hover,
                                color: it === locale
                                    ? theme.colors[colorMode].text.brand
                                    : theme.colors[colorMode].text.secondary,
                            }, onClick: () => handleClick(it), children: _jsx(Typography, { variant: "label", size: "md", fontWeight: it === locale ? 500 : 400, children: SUPPORTED_LOCALES[it] }) }, it))) }) })] })) }));
};
